<!--
 * @Author: 
 * @Date: 2022-06-29 15:19:07
 * @LastEditors: 
 * @LastEditTime: 2022-06-29 15:19:22
 * @FilePath: /Cup2Market/src/components/TheCartIcon.vue
 * @Description: 
-->
<template>
  <svg
    width="22px"
    height="22px"
    viewBox="0 0 22 22"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <title>编组 3</title>
    <g
      id="页面-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g id="品牌会场分销" transform="translate(-265.000000, -407.000000)">
        <rect fill="#8B8B8B" x="0" y="0" width="375" height="812"></rect>
        <rect
          id="底图"
          fill="#FFFFFF"
          x="0"
          y="44"
          width="375"
          height="1140"
        ></rect>
        <g id="编组-3" transform="translate(265.000000, 407.000000)">
          <circle
            id="椭圆形备份-4"
            stroke="currentColor"
            fill="#FFFFFF"
            cx="11"
            cy="11"
            r="10.5"
          ></circle>
          <g
            id="编组备份"
            transform="translate(5.000000, 5.000000)"
            fill="currentColor"
            fill-rule="nonzero"
          >
            <path
              d="M4.58960494,11.3972482 C3.96283027,11.3975234 3.45412414,10.8903689 3.45248486,10.2635963 C3.45385134,9.63663013 3.96263731,9.12917432 4.58960494,9.129449 C5.21657257,9.12917432 5.72535854,9.63663013 5.72672502,10.2635963 C5.72508574,10.8903689 5.21637961,11.3975234 4.58960494,11.3972482 Z M4.58960494,9.87365549 C4.48605485,9.87352431 4.38669367,9.91453336 4.31337978,9.98766142 C4.24006589,10.0607895 4.19880478,10.1600462 4.19867346,10.2635963 C4.19867346,10.479365 4.37358853,10.6542801 4.5893572,10.6542801 C4.80512588,10.6542801 4.98004095,10.479365 4.98004095,10.2635963 C4.97976755,10.048158 4.80504344,9.87365549 4.58960494,9.87365549 L4.58960494,9.87365549 Z M9.03254865,11.3972482 C8.40577397,11.3975234 7.89706784,10.8903689 7.89542856,10.2635963 C7.89679504,9.63663013 8.40558102,9.12917431 9.03254865,9.129449 C9.65951628,9.12917432 10.1683022,9.63663013 10.1696687,10.2635963 C10.1680299,10.8901755 9.65962541,11.3972482 9.03304412,11.3972482 L9.03254865,11.3972482 Z M9.03254865,9.87365549 C8.81711015,9.87365549 8.64238604,10.048158 8.64211264,10.2635963 C8.64211264,10.479365 8.81702771,10.6542801 9.03279638,10.6542801 C9.24856505,10.6542801 9.42348012,10.479365 9.42348012,10.2635963 C9.4233488,10.1600462 9.38208769,10.0607895 9.3087738,9.98766142 C9.23545991,9.91453337 9.13609874,9.87352432 9.03254865,9.87365549 L9.03254865,9.87365549 Z M9.751486,8.48879714 C9.73364882,8.48879714 9.71779355,8.48830166 9.70441568,8.48731071 L4.67581797,8.48731071 C4.20610562,8.48731071 3.8008053,8.31191179 3.47180846,7.96705969 C3.20078246,7.6826558 2.98326798,7.28627407 2.80588716,6.7541316 C2.49670941,5.82610287 2.35500294,4.6324984 2.20586432,3.36903164 C2.17910855,3.14606692 2.15185731,2.91567004 2.12411059,2.68973245 C2.01956491,1.84593484 1.74259317,1.24640748 1.32441045,0.955562386 C1.0718523,0.781690131 0.762164725,0.711451711 0.459307328,0.759353429 C0.329819435,0.790065869 0.193782796,0.749364366 0.102441097,0.652580781 C0.0110993983,0.555797195 -0.0216703837,0.417635258 0.0164758114,0.290139234 C0.0546220065,0.16264321 0.157888864,0.0651827791 0.287376758,0.0344703424 C0.318591817,0.0270381902 1.05387992,-0.138946667 1.75052081,0.344639047 C2.21181004,0.664717292 2.53932045,1.18001355 2.72809724,1.8816092 L2.73602489,1.8816092 L10.7473951,1.89845543 C11.1858924,1.89845543 11.4470089,2.0768272 11.5892108,2.2264613 C11.909289,2.56437673 11.8934338,3.02071119 11.8904609,3.07174534 L11.88947,3.08710514 L11.887488,3.1029604 C11.8850107,3.1183202 11.6595686,4.68947827 11.2309808,6.50837493 C11.0342764,7.34474038 10.7454132,7.92643056 10.3738053,8.23759022 C10.1181391,8.45213183 9.88328293,8.48879714 9.75198148,8.48879714 L9.751486,8.48879714 Z M2.86881277,2.62631137 L2.94759363,3.28182766 C3.09227296,4.5066472 3.22952013,5.66358637 3.5144195,6.51927543 C3.65463953,6.93944007 3.82211082,7.25406806 4.01286953,7.45374535 C4.20115085,7.65094525 4.41172865,7.74310401 4.67680893,7.74310401 L9.7559453,7.74310401 L9.76040459,7.74359949 C9.78517845,7.73814925 9.86495027,7.71188895 9.9749462,7.58851514 C10.1206165,7.42401672 10.3311943,7.07321889 10.5046113,6.33793079 C10.761395,5.24100927 10.9749455,4.13441452 11.1447678,3.02071119 C11.1437768,2.95877654 11.1249487,2.81855651 11.0446814,2.73531635 C10.9847287,2.67387718 10.8841468,2.64266213 10.7464041,2.64266213 L2.86831729,2.62631137 L2.86881277,2.62631137 Z"
              id="形状"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {};
</script>

<style>
</style>
